exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ExcelButton__ExcelButton__6Ery0 {\n    height: 3rem;\n    width: 3rem;\n    width: 100%;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: center;\n        justify-content: center;\n}\n\n.ExcelButton__ExcelButton__6Ery0 img {\n    height: 3rem;\n    cursor: pointer;\n    width: 3rem;\n}\n\n.ExcelButton__Hidden__1TVes {\n    display:none;\n}", ""]);

// exports
exports.locals = {
	"ExcelButton": "ExcelButton__ExcelButton__6Ery0",
	"Hidden": "ExcelButton__Hidden__1TVes"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/UI/Buttons/ExcelButton/ExcelButton.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/UI/Buttons/ExcelButton/ExcelButton.css
// module chunks = 0